import { apiGet } from "@/lib/apiClient";
import type { PlatformConstantsResponse } from "./defaults";

export async function fetchPlatformConstants(
  scope?: string,
): Promise<PlatformConstantsResponse> {
  const query = scope ? `?scope=${encodeURIComponent(scope)}` : "";
  return apiGet<PlatformConstantsResponse>(`/platform/constants${query}`);
}
